import { Component, Input } from '@angular/core';
import { EnvironmentVariablesService } from '@kenv';
import { ThemeService, productDisplayName } from '@kservice';
import { Product } from '@ktypes/enums';
import { MockComponent } from '@kutil/test';

@Component({
  selector: 'kp-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss'],
})
export class LoginHeaderComponent {
  constructor(private _environmentVariablesService: EnvironmentVariablesService, public themeService: ThemeService) {}

  @Input() signup = false;
  @Input() skipAnimationIntro = false;
  productName = productDisplayName;

  isPurposeful = this._environmentVariablesService.product === Product.purposeful;
}

export const MockLoginHeaderComponent = MockComponent({
  selector: 'kp-login-header',
  inputs: ['skipAnimationIntro', 'signup'],
});
